import React from 'react';
import { IS_IOS } from './platformDetector';

export const getMailtoAnchor = (email, content = '') => {
  if (!email) return '';
  if (!IS_IOS) return <a href={`mailto:${email}`}>{content || email}</a>;
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <a onClick={() => window.location.href = `mailto:${email}`}>{content || email}</a>
};
